export default "__VITE_ASSET__3IuWcprM__"